var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"white black--text"},[_c('cpnChartSelect',{attrs:{"power_plants":_vm.power_plants}})],1),_c('v-container',{attrs:{"fill-height":"","fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"wrap":""}},[(!_vm.loading)?_c('cpnCustomerMetrics'):_vm._e(),(!_vm.loading)?_c('cpnChartBilling'):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }